<ng-container *t="let t">
  <form [formGroup]="bankForm" (ngSubmit)="onBankDetailsSubmit()" class="step-container" autocomplete="off">
    <div class="grid">
      <div class="row" *ngIf="errors">
        <ul>
          <li *ngFor="let error of errors" class="error">
            <div>{{ error }}</div>
          </li>
        </ul>
      </div>
      <tsl-alert status="success" *ngIf="supplierBank?.VerificationStatus == 'VERIFIED'">The banking data has
        successfully been verified! Please continue to complete the Tesla banking submission.</tsl-alert>
      <tsl-alert status="warning" *ngIf="supplierBank?.VerificationStatus == 'PENDING_DEPOSIT'">Please navigate back to
        this tab and click on confirm microdeposits once you have received both microdeposits from Tesla Plaid via your
        provided banking information.</tsl-alert>
      <tsl-alert status="warning" *ngIf="supplierBank?.VerificationStatus == 'PENDING_VERIFICATION'">The banking
        connected is pending verification. <a (click)="verify()" class="link">Confirm Microdeposits</a> to verify the
        banking. Please note that Plaid's authentication of your organization's confirmed microdeposits may take up to
        several hours. Please revisit this tab at a later time to ensure the Plaid authentication of your banking
        information has been completed.
      </tsl-alert>
      <div class="bank-section-main">
        <div class="bank-section-container row">
          <div class="bank-address-header two-items-title">
            <span i18n="@@BankAccountInformation" t="BankAccountInformation">Bank Account Information</span>
            <a *ngIf="isPlaidEnabled() && !readOnly" (click)="triggerPlaidAddAccount(bankForm.get('Country')?.value)"
              class="link">Change Linked Account</a>
          </div>
          <div class="col-4">
            <tsl-select-autocomplete #countryAutocomplete [tsl-formControl]="bankForm.get('Country')"
              [tsl-labelText]="'Country'" [tsl-inputPlaceholder]="translate.get('Select country...')"
              [tsl-errorMessage]="'Please select a country'" [tsl-options]="countries" [tsl-textFieldName]="'name'"
              [tsl-valueFieldName]="'abbreviation'" (tsl-selectionChanged)="onCountryChanged($event.value)">
            </tsl-select-autocomplete>
            <tsl-error style="font-size: 12px;" *ngIf="BankformControls.Country.hasError('CountryAutoCompleteError')">
              <span i18n="@@2740236561190314005" t="2740236561190314005">Select Country from the list</span>
            </tsl-error>
          </div>
          <div class="col-4" *ngIf="showPaymentOriginControl">
            <tsl-select-autocomplete #paymentOriginAutocomplete [tsl-formControl]="bankForm.get('PaymentOrigin')"
              [tsl-labelText]="'Payment Origin'" [tsl-inputPlaceholder]="translate.get('Select payment origin...')"
              [tsl-errorMessage]="'Please select a payment origin'" [tsl-options]="paymentOrigins"
              [tsl-textFieldName]="'Key'" [tsl-valueFieldName]="'Value'"
              (tsl-selectionChanged)="onPaymentOriginChanged($event.value)">
            </tsl-select-autocomplete>
          </div>
          <div class="col-4">
            <tsl-select-autocomplete #currecyAutocomplete [tsl-formControl]="bankForm.get('Currency')"
              [tsl-labelText]="'Bank Currency'" [tsl-inputPlaceholder]="translate.get('Select currency...')"
              [tsl-errorMessage]="'Please select a currency'" [tsl-options]="currencies"
              [tsl-textSelector]="currencyTextSelector" [tsl-valueSelector]="currecyValueSelector"
              (tsl-selectionChanged)="onCurrencyChanged($event.value)">
            </tsl-select-autocomplete>
            <tsl-error style="font-size: 12px;" *ngIf="BankformControls.Currency.hasError('CurrencyAutoCompleteError')">
              <span i18n="@@7281168646996544322" t="7281168646996544322">Select Currency from the list</span>
            </tsl-error>
          </div>
          <div class="col-4">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@dcf35f191c0f3861cb5a3a90c6106c8cbfb8a806"
                t="dcf35f191c0f3861cb5a3a90c6106c8cbfb8a806">Bank Name</tsl-label>
              <input tslInput fullWidth shape="round" formControlName="Name" name="txtName" tslTooltipPosition="after"
                maxlength="60" #recipientBankName i18n-tooltip="@@5514515253334467872"
                tooltip="Name of the recipient bank" tslTooltip="{{ t('5514515253334467872', recipientBankName) }}" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.Name?.value?.length || 0}} / 60
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.Name.errors && (BankformControls.Name.dirty || BankformControls.Name.touched)">
                <span>{{getValidationMessages('Name','Name', BankformControls.Name)}} </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.bankLocalName?.required)">
            <tsl-form-field class="w-100">
              <tsl-label><span style="font-family: 'Universal Sans Text';" i18n="@@4862759528924544211" t="4862759528924544211">Bank Name (Local Language)</span>
                <tsl-icon *ngIf="isChina && languageSelected != 'zh-CN'" size="small" tooltip="Bank name matching bank document"
                i18n-tooltip="@@BankNameHelpTooltip" #bankNameTooltip tslTooltip="{{ t('BankNameHelpTooltip', bankNameTooltip) }}">help</tsl-icon>
                <tsl-icon *ngIf="isChina && languageSelected == 'zh-CN'" size="small" tslTooltip="需与银行文件完全一致">help</tsl-icon>
              </tsl-label>
              <input tslInput fullWidth shape="round" formControlName="BankLocalName" name="txtName"
                tslTooltipPosition="after" maxlength="60" #recipientBankNameLocal i18n-tooltip="@@3615610053389293615"
                tooltip="Name of the recipient bank in local language"
                tslTooltip="{{ t('3615610053389293615', recipientBankNameLocal) }}" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.BankLocalName?.value?.length || 0}} / 60
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.BankLocalName.errors && (BankformControls.BankLocalName.dirty || BankformControls.BankLocalName.touched)">
                <span>{{getValidationMessages('BankLocalName','BankLocalName', BankformControls.BankLocalName)}} </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@7c29002cc49d524bddc022ee2fe7603702cffc09"
                t="7c29002cc49d524bddc022ee2fe7603702cffc09">Bank Nick Name</tsl-label>
              <input tslInput fullWidth shape="round" formControlName="NickName" name="txtNickName"
                tslTooltipPosition="after" maxlength="20" tooltip="Nick name of the recipient bank"
                i18n-tooltip="@@3424042631819386770" #nicName tslTooltip="{{ t('3424042631819386770', nicName) }}" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.NickName?.value?.length || 0}} / 20
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.NickName.errors && (BankformControls.NickName.dirty || BankformControls.NickName.touched)">
                <span>{{getValidationMessages('NickName', 'Nick Name', BankformControls.NickName)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4"
            *ngIf="bankConfiguration && showControl(bankConfiguration?.beneficiaryNameEnglish?.required)">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@1c80ff41fd2b1e31cec85e6e7ed3927748392c0a"
                t="1c80ff41fd2b1e31cec85e6e7ed3927748392c0a">Beneficiary Name</tsl-label>
              <input tslInput fullWidth shape="round" formControlName="BeneficiaryNameEnglish" (change)="onBeneficiaryNameEnglishChange($event)"
                name="txtBeneficiaryNameEnglish" tslTooltipPosition="after" maxlength="60" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.BeneficiaryNameEnglish?.value?.length || 0}} / 60
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.BeneficiaryNameEnglish.errors && (BankformControls.BeneficiaryNameEnglish.dirty || BankformControls.BeneficiaryNameEnglish.touched)">
                <span>{{getValidationMessages('beneficiaryNameEnglish', 'Beneficiary Name (English)',
                  BankformControls.BeneficiaryNameEnglish)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-8" *ngIf="showNameDifferentReason">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@BankNameDifferentReasonLabel"
                t="BankNameDifferentReasonLabel">Please provide a reason for your organization’s name not matching the beneficiary/account holder name of the banking information on file</tsl-label>
              <tsl-select formControlName="BeneficiaryNameDifferentReason" name="BeneficiaryNameDifferentReason" shape="round" contentWidth="content">
                <tsl-option *ngFor="let reason of beneficiaryNameDifferentReasons"
                  [value]="reason">
                  {{translate.get(reason)}}
                </tsl-option>
              </tsl-select>
              <tsl-error
                *ngIf="BankformControls.BeneficiaryNameDifferentReason.errors && (BankformControls.BeneficiaryNameDifferentReason.dirty || BankformControls.BeneficiaryNameDifferentReason.touched)">
                <span>{{getValidationMessages('beneficiaryNameDifferentReason', 'Beneficiary Name Different Reason',
                  BankformControls.BeneficiaryNameDifferentReason)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4"
            *ngIf="showNameDifferentReasonComment">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@BankNameDifferentReasonCommentLabel"
                t="BankNameDifferentReasonCommentLabel">Please provide further details on the name difference</tsl-label>
              <input tslInput fullWidth shape="round" formControlName="BeneficiaryNameDifferentReasonComment"
                name="BeneficiaryNameDifferentReasonComment" maxlength="250" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.BeneficiaryNameDifferentReasonComment?.value?.length || 0}} / 250
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.BeneficiaryNameDifferentReasonComment.errors && (BankformControls.BeneficiaryNameDifferentReasonComment.dirty || BankformControls.BeneficiaryNameDifferentReasonComment.touched)">
                <span>{{getValidationMessages('beneficiaryNameDifferentReasonComment', 'Beneficiary Name Different Reason Comment',
                  BankformControls.BeneficiaryNameDifferentReasonComment)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4"
            *ngIf="bankConfiguration && showControl(bankConfiguration?.beneficiaryNameLocal?.required)">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@d9599fc3cabcad4ff36e4697ae8ee4639f7d9df6"
                t="d9599fc3cabcad4ff36e4697ae8ee4639f7d9df6">Beneficiary Local Name</tsl-label>
              <input tslInput fullWidth shape="round" formControlName="BeneficiaryNameLocal"
                name="txtBeneficiaryNameLocal" tslTooltipPosition="after" maxlength="60" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.BeneficiaryNameLocal?.value?.length || 0}} / 60
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.BeneficiaryNameLocal.errors && (BankformControls.BeneficiaryNameLocal.dirty || BankformControls.BeneficiaryNameLocal.touched)">
                <span>{{getValidationMessages('beneficiaryNameLocal', 'BeneficiaryNameLocal',
                  BankformControls.BeneficiaryNameLocal)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.accountNumber?.required)">
            <tsl-label *ngIf="disableSensitiveFieldModification" i18n="@@54f38294b5e75eef4039e24a46ad7d499ea833a9" t="54f38294b5e75eef4039e24a46ad7d499ea833a9">Account
              number</tsl-label>
            <tsl-label disabled tslInput fullWidth shape="round" class="label-input" *ngIf="disableSensitiveFieldModification && supplierBank?.Last4AccountNumber?.length > 0">****{{supplierBank?.Last4AccountNumber}}</tsl-label>
            <div *ngIf="!disableSensitiveFieldModification">
              <tsl-form-field class="w-100">
                <tsl-label i18n="@@54f38294b5e75eef4039e24a46ad7d499ea833a9"
                  t="54f38294b5e75eef4039e24a46ad7d499ea833a9">Account number</tsl-label>
                <input tslInput fullWidth shape="round" formControlName="AccountNumber" name="txtAccountNumber" />
                <a class="link inline-icon" (click)="editAccountNumber()" *ngIf="showAccountNumberEdit"
                  tooltip="Click to edit account number" i18n-tooltip="@@53313363552030660" #editAmountNumberButton
                  tslTooltip="{{ t('53313363552030660', editAmountNumberButton) }}">
                  <tsl-icon class="input-inline">edit</tsl-icon>
                </a>
                <tsl-error
                  *ngIf="BankformControls.AccountNumber.errors && (BankformControls.AccountNumber.dirty || BankformControls.AccountNumber.touched)">
                  <span>{{getValidationMessages('accountNumber', 'Account Number',
                    BankformControls.AccountNumber)}}
                  </span>
                </tsl-error>
              </tsl-form-field>
            </div>
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.routingCode?.required)">
            <tsl-form-field class="w-100">
              <tsl-label>
                {{bankConfiguration && bankConfiguration.routingCode?.label || translate.get('Routing Number')}}
              </tsl-label>
              <input tslInput fullWidth shape="round" formControlName="RoutingCode" name="txtRoutingCode"
                tslTooltip="{{bankConfiguration?.routingCode?.helpText || ''}}"
                [tslTooltipDisabled]="!bankConfiguration?.routingCode?.helpText" tslTooltipPosition="after"
                [withArrow]="true" i18n-tslTooltip />
              <tsl-error
                *ngIf="BankformControls.RoutingCode.errors && (BankformControls.RoutingCode.dirty || BankformControls.RoutingCode.touched)">
                <span>{{getValidationMessages('routingCode', bankConfiguration.routingCode?.label,
                  BankformControls.RoutingCode)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.iban?.required)">
            <tsl-label *ngIf="disableSensitiveFieldModification" i18n="@@3ce1e1ad4e78ff2d5c8d77eedcf1edd429b4b6e6"
              t="3ce1e1ad4e78ff2d5c8d77eedcf1edd429b4b6e6">IBAN Code</tsl-label>
            <tsl-label disabled tslInput fullWidth shape="round" class="label-input" *ngIf="disableSensitiveFieldModification"><span *ngIf="supplierBank?.Last4IBANCode?.length > 0">****{{supplierBank?.Last4IBANCode}}</span></tsl-label>
            <div *ngIf="!disableSensitiveFieldModification">
              <tsl-form-field class="w-100">
                <tsl-label i18n="@@3ce1e1ad4e78ff2d5c8d77eedcf1edd429b4b6e6"
                  t="3ce1e1ad4e78ff2d5c8d77eedcf1edd429b4b6e6">IBAN Code</tsl-label>
                <input tslInput fullWidth shape="round" formControlName="IBANCode" name="txtIBANCode" (blur)="valiateIban()"
                  tslTooltipPosition="after"
                  tooltip="International Bank Account Number - bank account number used for some foreign countries"
                  i18n-tooltip="@@8060401449744005247" #internationalBankAccountNumber
                  tslTooltip="{{ t('8060401449744005247', internationalBankAccountNumber) }}" />
                <a class="link inline-icon" (click)="editIBanCode()" *ngIf="showIBANEdit" tooltip="Click to edit IBAN"
                  i18n-tooltip="@@5169587792184292399" #editIBM tslTooltip="{{ t('5169587792184292399', editIBM) }}">
                  <tsl-icon class="input-inline">edit</tsl-icon>
                </a>
                <tsl-error
                  *ngIf="BankformControls.IBANCode.errors && (BankformControls.IBANCode.dirty || BankformControls.IBANCode.touched)">
                  <span>{{getValidationMessages('iban', 'IBAN Code', BankformControls.IBANCode)}}
                  </span>
                </tsl-error>
              </tsl-form-field>
            </div>
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.swiftCode?.required)">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@132a6c998d48cd7b8c41cb1feb2a5df10c951335"
                t="132a6c998d48cd7b8c41cb1feb2a5df10c951335">Swift Code</tsl-label>
              <input tslInput fullWidth shape="round" formControlName="SwiftCode" name="txtSwiftCode"
                tslTooltipPosition="after" tooltip="Alphanumeric code used to specify a foreign recipient bank branch"
                i18n-tooltip="@@8719458057140542483" #alphanumericCodeHelp
                tslTooltip="{{ t('8719458057140542483', alphanumericCodeHelp) }}" />
              <tsl-error
                *ngIf="BankformControls.SwiftCode.errors && (BankformControls.SwiftCode.dirty || BankformControls.SwiftCode.touched)">
                <span>{{getValidationMessages('swiftCode', 'Swift Code', BankformControls.SwiftCode)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.paymentType?.required)">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@534aeba22240612ae0b9a76a9ddc20cec6fe2519"
                t="534aeba22240612ae0b9a76a9ddc20cec6fe2519">Payment Type</tsl-label>
              <tsl-select triggerIcon="location_on" formControlName="PaymentType" name="PaymentType" shape="round">
                <tsl-option i18n="@@9ca82952a6bc860b5391d5975322d8af8ceddfa4"
                  t="9ca82952a6bc860b5391d5975322d8af8ceddfa4">Select</tsl-option>
                <tsl-option *ngFor="let paymentType of bankConfiguration.paymentType.values"
                  [value]="fetchDropdownKey(paymentType)">
                  {{translate.get(fetchDropdownValue(paymentType))}}
                </tsl-option>
              </tsl-select>
              <tsl-error
                *ngIf="BankformControls.PaymentType.errors && (BankformControls.PaymentType.dirty || BankformControls.PaymentType.touched)">
                <span>{{getValidationMessages('paymentType', 'Payment Type',
                  BankformControls.PaymentType)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.bankAccountKatanaka?.required)">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@f985bdb0b9c090c598cbb787f4e2e3569ade8727"
                t="f985bdb0b9c090c598cbb787f4e2e3569ade8727">Bank account name (Katakana)</tsl-label>
              <input tslInput shape="round" [ngClass]="displayFieldCss('BankAccountNameKatanaka')"
                formControlName="BankAccountNameKatanaka" name="txtBankAccountNameKatanaka" />
              <tsl-error
                *ngIf="BankformControls.BankAccountNameKatanaka.errors && (BankformControls.BankAccountNameKatanaka.dirty || BankformControls.BankAccountNameKatanaka.touched)">
                <span>{{getValidationMessages('bankAccountKatanaka', 'Bank Account Name',
                  BankformControls.BankAccountNameKatanaka)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.bankAccountType?.required)">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@9a68b55938135fb87550c895fa524ea811cf63e5"
                t="9a68b55938135fb87550c895fa524ea811cf63e5">Bank Account Type</tsl-label>
              <tsl-select triggerIcon="location_on" [ngClass]="displayFieldCss('BankAccountType')" shape="round"
                formControlName="BankAccountType">
                <tsl-option [value]="0" i18n="@@9ca82952a6bc860b5391d5975322d8af8ceddfa4"
                  t="9ca82952a6bc860b5391d5975322d8af8ceddfa4">Select</tsl-option>
                <tsl-option *ngFor="let accountType of bankConfiguration.bankAccountType.values"
                  [value]="fetchDropdownKey(accountType)">
                  {{translate.get(fetchDropdownValue(accountType))}}
                </tsl-option>
              </tsl-select>
              <tsl-error
                *ngIf="BankformControls.BankAccountType.errors && (BankformControls.BankAccountType.dirty || BankformControls.BankAccountType.touched)">
                <span>{{getValidationMessages('bankAccountType', 'Bank Account Type',
                  BankformControls.BankAccountType)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
        </div>
        <div class="bank-section-container row">
          <div class="bank-address-header"
            *ngIf="bankConfiguration && showControl(bankConfiguration?.address1?.required)"
            i18n="@@AddressOfBankInstitution" t="AddressOfBankInstitution">Address of Bank Institution
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.address1?.required)">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@StreetAddressLine1" t="StreetAddressLine1">Street Address Line 1</tsl-label>
              <input shape="round" tslInput formControlName="Address1" name="txtAddress1" maxlength="50" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.Address1?.value?.length || 0}} / 50
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.Address1.errors && (BankformControls.Address1.dirty || BankformControls.Address1.touched)">
                <span>{{getValidationMessages('address1', 'Street Address Line 1',
                  BankformControls.Address1)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.address2?.required)">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@StreetAddressLine2" t="StreetAddressLine2">Street Address Line 2</tsl-label>
              <input shape="round" tslInput formControlName="Address2" name="txtAddress2" maxlength="50" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.Address2?.value?.length || 0}} / 50
              </tsl-hint>
              <mat-error
                *ngIf="BankformControls.Address2.errors && (BankformControls.Address2.dirty || BankformControls.Address2.touched)">
                <span>{{getValidationMessages('address2', 'Street Address Line 2',
                  BankformControls.Address2)}}
                </span>
              </mat-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.city?.required)">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@City" t="City">City</tsl-label>
              <input shape="round" tslInput formControlName="City" name="txtCity" maxlength="30" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.City?.value?.length || 0}} / 30
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.City.errors && (BankformControls.City.dirty || BankformControls.City.touched)">
                <span>{{getValidationMessages('city', 'City', BankformControls.City)}} </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.state?.required)">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@StateCounty" t="StateCounty">State/County</tsl-label>
              <input shape="round" tslInput formControlName="State" name="txtState" [maxlength]="USAstate==true? 2: 30"/>

              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.State?.value?.length || 0}} / 30
              </tsl-hint>
              <tsl-error
              *ngIf="BankformControls.State.dirty || BankformControls.State.touched">
              <span i18n="@@eb5e63d466a879c0da4d461c29d36c97fc78cf30" t="eb5e63d466a879c0da4d461c29d36c97fc78cf30" *ngIf="BankformControls.State.hasError('required')">State is Required </span>
              <span i18n="@@usstatevalidationMessage" t="usstatevalidationMessage" *ngIf="BankformControls.State.hasError('invalidFormat')">For country USA, State should be of 2 capital character abbreviation</span>
              <span i18n="@@notavalidnameforusastates" t="notavalidnameforusastates" *ngIf="BankformControls.State.hasError('invalidState')">Not a valid State Name for Country USA.</span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="bankConfiguration && showControl(bankConfiguration?.zipCode?.required)">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@ZipCode" t="ZipCode">Zip Code</tsl-label>
              <input shape="round" tslInput formControlName="ZipCode" name="txtZipCode" maxlength="10" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.ZipCode?.value?.length || 0}} / 10
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.ZipCode.errors && (BankformControls.ZipCode.dirty || BankformControls.ZipCode.touched)">
                <span>{{getValidationMessages('zipCode', 'Zip Code', BankformControls.ZipCode)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-12">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@c5bb9f8936cb33db2ca351a1b87a984fdf11917c"
                t="c5bb9f8936cb33db2ca351a1b87a984fdf11917c">Comments</tsl-label>
              <textarea shape="round" tslInput formControlName="Comments" name="txtComments" maxlength="100"></textarea>
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.Comments?.value?.length || 0}} /
                100</tsl-hint>
            </tsl-form-field>
          </div>
        </div>
        <div class="bank-checkbox-container row">
          <div class="col-4">
            <tsl-checkbox formControlName="IsIntermediaryBanking">
              <span i18n="@@1860109931969958002" t="1860109931969958002">Add Intermediary Banking</span>
            </tsl-checkbox>
          </div>
          <div class="col-4" *ngIf="showIntermediaryBankingFields">
            <tsl-select-autocomplete #paymentOriginAutocomplete [tsl-formControl]="bankForm.get('IntermediaryPaymentOrigin')"
              [tsl-labelText]="'Intermediary Payment Origin'" [tsl-inputPlaceholder]="translate.get('Select payment origin...')"
              [tsl-errorMessage]="'Please select a payment origin'" [tsl-options]="intermediaryPaymentOrigins"
              [tsl-textFieldName]="'Key'" [tsl-valueFieldName]="'Value'">
            </tsl-select-autocomplete>
          </div>
        </div>
        <div class="bank-section-container row">
          <div class="bank-address-header"
            *ngIf="showIntermediaryBankingFields"
            i18n="@@IntermediaryBankInformation" t="IntermediaryBankInformation">Intermediary Bank Information
          </div>
          <div class="col-4" *ngIf="showIntermediaryBankingFields">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@5171956678184469619" t="5171956678184469619">Intermediary Bank Name</tsl-label>
              <input shape="round" tslInput formControlName="IntermediaryBankName" name="txtIntermediaryBankName"
                maxlength="100" />
              <tsl-error
                *ngIf="BankformControls.IntermediaryBankName.errors && (BankformControls.IntermediaryBankName.dirty || BankformControls.IntermediaryBankName.touched)">
                <span>{{getValidationMessages('intermediaryBankName', 'Intermediary Bank Name',
                  BankformControls.IntermediaryBankName)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="showIntermediaryBankingFields">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@7107555759805729834" t="7107555759805729834">Intermediary Bank Routing</tsl-label>
              <input shape="round" tslInput formControlName="IntermediaryBankRouting" name="txtIntermediaryBankRouting"
                maxlength="100" />
              <tsl-error
                *ngIf="BankformControls.IntermediaryBankRouting.errors && (BankformControls.IntermediaryBankRouting.dirty || BankformControls.IntermediaryBankRouting.touched)">
                <span>{{getValidationMessages('intermediaryBankRouting', 'Intermediary Bank Routing',
                  BankformControls.IntermediaryBankRouting)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="showIntermediaryBankingFields">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@2544882618558971090" t="2544882618558971090">Intermediary Bank SwiftCode</tsl-label>
              <input shape="round" tslInput formControlName="IntermediaryBankSwiftCode"
                name="txtIntermediaryBankSwiftCode" maxlength="100" />
              <tsl-error
                *ngIf="BankformControls.IntermediaryBankSwiftCode.errors && (BankformControls.IntermediaryBankSwiftCode.dirty || BankformControls.IntermediaryBankSwiftCode.touched)">
                <span>{{getValidationMessages('intermediaryBankSwiftCode', 'Intermediary Bank SwiftCode',
                  BankformControls.IntermediaryBankSwiftCode)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="showIntermediaryBankingFields">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@9212681924569230136" t="9212681924569230136">Intermediary Bank Account</tsl-label>
              <input shape="round" tslInput formControlName="IntermediaryBankAccount" name="txtIntermediaryBankAccount"
                maxlength="50" />
              <a class="link inline-icon" (click)="editIntermediaryAccountNumber()" *ngIf="showIntermAccountNumberEdit"
                tooltip="Click to edit account number" i18n-tooltip="@@53313363552030660" #editIntermediaryBankAccount
                tslTooltip="{{ t('53313363552030660', editIntermediaryBankAccount) }}">
                <tsl-icon class="input-inline">edit</tsl-icon>
              </a>
              <tsl-error
                *ngIf="BankformControls.IntermediaryBankAccount.errors && (BankformControls.IntermediaryBankAccount.dirty || BankformControls.IntermediaryBankAccount.touched)">
                <span>{{getValidationMessages('intermediaryBankAccount', 'Intermediary Bank Account',
                  BankformControls.IntermediaryBankAccount)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="showIntermediaryBankingFields">
            <tsl-select-autocomplete #intermCountryAutocomplete
              [tsl-formControl]="bankForm.get('IntermediaryCountryCode')" [tsl-labelText]="translate.get('Intermediary Bank Country')"
              [tsl-inputPlaceholder]="translate.get('Select country...')" [tsl-errorMessage]="'Please select a country'"
              [tsl-options]="countries" [tsl-textFieldName]="'name'" [tsl-valueFieldName]="'abbreviation'">
            </tsl-select-autocomplete>
            <tsl-error style="font-size: 12px;"
              *ngIf="BankformControls.IntermediaryCountryCode.hasError('CountryAutoCompleteError')">
              <span i18n="@@5761720403264919078" t="5761720403264919078">Select Country from the list</span>
            </tsl-error>
          </div>
          <div class="col-4" *ngIf="showIntermediaryBankingFields">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@1044728165379334550" t="1044728165379334550">Intermediary Street Address Line
                1</tsl-label>
              <input shape="round" tslInput formControlName="IntermediaryAddress1" name="txtIntermediaryAddress1"
                maxlength="50" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.IntermediaryAddress1?.value?.length || 0}} / 50
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.IntermediaryAddress1.errors && (BankformControls.IntermediaryAddress1.dirty || BankformControls.IntermediaryAddress1.touched)">
                <span>{{getValidationMessages('intermediaryAddress1', 'Intermediary Street Address Line 1',
                  BankformControls.IntermediaryAddress1)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="showIntermediaryBankingFields">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@1988215339165569129" t="1988215339165569129">Intermediary Street Address Line
                2</tsl-label>
              <input shape="round" tslInput formControlName="IntermediaryAddress2" name="txtIntermediaryAddress2"
                maxlength="50" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.IntermediaryAddress2?.value?.length || 0}} / 50
              </tsl-hint>
              <mat-error
                *ngIf="BankformControls.IntermediaryAddress2.errors && (BankformControls.IntermediaryAddress2.dirty || BankformControls.IntermediaryAddress2.touched)">
                <span>{{getValidationMessages('intermediaryAddress2', 'Intermediary Street Address Line 2',
                  BankformControls.IntermediaryAddress2)}}
                </span>
              </mat-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="showIntermediaryBankingFields">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@2416684580683741889" t="2416684580683741889">Intermediary City</tsl-label>
              <input shape="round" tslInput formControlName="IntermediaryCity" name="txtIntermediaryCity"
                maxlength="30" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.IntermediaryCity?.value?.length || 0}} / 30
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.IntermediaryCity.errors && (BankformControls.IntermediaryCity.dirty || BankformControls.IntermediaryCity.touched)">
                <span>{{getValidationMessages('intermediaryCity', 'Intermediary City',
                  BankformControls.IntermediaryCity)}} </span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="showIntermediaryBankingFields">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@1604851389911889914" t="1604851389911889914">Intermediary State/County</tsl-label>
              <input shape="round" tslInput formControlName="IntermediaryState" name="txtIntermediaryState"
              [maxlength]="USAstate==true ? 2 :30"/>
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.IntermediaryState?.value?.length || 0}} / 30
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.IntermediaryState.dirty || BankformControls.IntermediaryState.touched">
                <span i18n="@@eb5e63d466a879c0da4d461c29d36c97fc78cf30" t="eb5e63d466a879c0da4d461c29d36c97fc78cf30" *ngIf="BankformControls.IntermediaryState.hasError('required')">State is Required </span>
                <span i18n="@@usstatevalidationMessage" t="usstatevalidationMessage" *ngIf="BankformControls.IntermediaryState.hasError('invalidFormat')">For country USA, State should be of 2 capital character abbreviation</span>
                <span i18n="@@notavalidnameforusastates" t="notavalidnameforusastates" *ngIf="BankformControls.IntermediaryState.hasError('invalidState')">Not a valid State Name for Country USA.</span>
              </tsl-error>
            </tsl-form-field>
          </div>
          <div class="col-4" *ngIf="showIntermediaryBankingFields">
            <tsl-form-field class="w-100">
              <tsl-label i18n="@@7536967890086708465" t="7536967890086708465">Intermediary Zip Code</tsl-label>
              <input shape="round" tslInput formControlName="IntermediaryZipCode" name="txtIntermediaryZipCode"
                maxlength="10" />
              <tsl-hint align="below" class="max-length-hint">
                {{BankformControls?.IntermediaryZipCode?.value?.length || 0}} / 10
              </tsl-hint>
              <tsl-error
                *ngIf="BankformControls.IntermediaryZipCode.errors && (BankformControls.IntermediaryZipCode.dirty || BankformControls.IntermediaryZipCode.touched)">
                <span>{{getValidationMessages('intermediaryZipCode', 'Intermediary Zip Code',
                  BankformControls.IntermediaryZipCode)}}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
        </div>
      </div>
    </div>
  </form>
  <ng-container *ngIf="!hideDocumentSection">
    <form [formGroup]="documentsForm" (ngSubmit)="onDocumentsSubmit()" class="step-container" autocomplete="off">
        <div class="bank-address-header" style="margin: 10px 0;" i18n="@@CorrespondingBankDocument" t="CorrespondingBankDocument">Corresponding Bank Document
      </div>
      <div class="grid" style="padding: 0 15px;">
        <div class="row">
          <div fxFlex>
            <tsl-accordion [multiple]="true">
              <tsl-accordion-group [expanded]="true" [disabled]="true">
                <tsl-accordion-header>
                  <tsl-accordion-group-title>
                    <div>
                      <tsl-icon style="margin-right: 5px;" status="primary" size="small">info</tsl-icon>
                      <span style="color: #3E6AE1;" i18n="@@HelpVerbiage" t="HelpVerbiage" class="BankTaskHelpTitle-verbiage">Please upload a supporting Bank Document that aligns with the below document requirements</span>
                    </div>
                  </tsl-accordion-group-title>
                </tsl-accordion-header>
                <p style="margin-top: 0;" i18n="@@4615955637944866710" t="4615955637944866710">These are examples of accepted Bank Documents.Please
                  choose one of the following.</p>
                <ul>
                  <li i18n="@@4317585035098248521" t="4317585035098248521">Screenshot of your online bank portal website
                    with the URL</li>
                  <li i18n="@@1435166140383080343" t="1435166140383080343">Copy of a bank statement or monthly
                    reconciliation document</li>
                  <li i18n="@@3625070939775410348" t="3625070939775410348">Bank issued Cover Letter/Letterhead</li>
                  <li i18n="@@2136902622392115910" t="2136902622392115910">Bank Issued Book (APAC Suppliers only) - Needs to
                    contain a red Company chop
                  </li>
                </ul>
                <p i18n="@@1162677928064347294" t="1162677928064347294">Each bank document must include the following:</p>
                <ul>
                  <li i18n="@@3282638243170785349" t="3282638243170785349">Bank Name and Information</li>
                  <li i18n="@@1c80ff41fd2b1e31cec85e6e7ed3927748392c0a" t="1c80ff41fd2b1e31cec85e6e7ed3927748392c0a">
                    Beneficiary Name</li>
                  <li i18n="@@3715559186429164442" t="3715559186429164442">Beneficiary/Account Holder Bank Account Number - The document needs to show entire bank account number; masked bank account numbers will not be accepted</li>
                  <li i18n="@@9073006068878341230" t="9073006068878341230">Swift Code (If receiving a wire payment)</li>
                </ul>
                <p class="document-warning-message">
                  <b i18n="@@03ca2681c3c667d2c484763d12585fd4ffc0c467" t="03ca2681c3c667d2c484763d12585fd4ffc0c467">
                    Please note voided checks, deposit slips, and invoices are not acceptable forms of
                    banking documentation.
                  </b>
                </p>
                <button tsl-button color="black" appearance="ghost" size="medium" class="mb-3 document-download-template-button" (click)="downloadSampleDocument()">
                  <tsl-icon>download</tsl-icon> <span i18n="@@6777998693446985539" t="6777998693446985539">Download Bank Document Example</span>
                </button>
              </tsl-accordion-group>
            </tsl-accordion>

          </div>
        </div>
        <div class="row">
          <tsl-file-drop [inputText]="translate.get('choose a file')" [hintText]="translate.get('Drag and Drop a File or ')" class="w-100" #fileDrop [accept]="'*'" (fileChange)="onFileAdd($event)">
          </tsl-file-drop>
        </div>
        <div class="row">
          <div *ngIf="!skipBankDocumentValidation()" class="right error">
            <span *ngIf="documents.length <= 0" i18n="@@307e220141685dec8324298099456073e3153242" t="307e220141685dec8324298099456073e3153242">Upload at least one document.</span>
            <span *ngIf="documents.length > 0 && !this.documentsForm.valid" i18n="@@PleaseProvideEffectiveDate" t="PleaseProvideEffectiveDate">Please provide effective date.</span>
          </div>
          <div *ngIf="invalidDoc" class="right error">
            <span i18n="@@484019509374873039" t="484019509374873039" [tParams]="[allowedExtensions]">Document selected is
              not in valid format, only {{allowedExtensions}} file is allowed.</span>
          </div>
        </div>
        <div *ngIf="documents.length > 0">
          <div class="row row-header">
            <div class="col-6">
              <tsl-label class="label" i18n="@@Document" t="Document">Document</tsl-label>
            </div>
            <div class="col-4">
              <tsl-label class="label" i18n="@@f0e56bb50e6ed6836e87d78d254177da229a07d1"
                t="f0e56bb50e6ed6836e87d78d254177da229a07d1">Effective Date</tsl-label>
            </div>
            <div class="col-2">
              <tsl-label class="label" i18n="@@019d4bd6a5690f0cfa0ecf346a4e6bf7f0d8debb"
                t="019d4bd6a5690f0cfa0ecf346a4e6bf7f0d8debb">Remove</tsl-label>
            </div>
          </div>
          <div class="row row-item" formArrayName="documents" *ngFor="let doc of documents['controls']; let i = index;">
            <div [formGroupName]="i" class="row">
              <div class="col-6">
                <a style="text-decoration: underline; color: #3E6AE1; cursor: pointer; word-break: break-all;"
                  (click)="download(doc)">{{doc.get('fileName').value}}</a>
              </div>
              <div class="col-4">
                <tsl-form-field class="w-100">
                  <tsl-datepicker singleSelection required shape="round" formControlName="effectiveDate" [selectYear]="true" [readonly]="true">
                  </tsl-datepicker>
                  <tsl-error
                    *ngIf="doc.get('effectiveDate').errors && (doc.get('effectiveDate').dirty || doc.get('effectiveDate').touched)">
                    <span i18n="@@4f98573061b4be0321028de36aaa943ab7883c56"
                      t="4f98573061b4be0321028de36aaa943ab7883c56">Effective Date is Required </span>
                  </tsl-error>
                </tsl-form-field>
              </div>
              <div class="col-2">
                <button *ngIf="!readOnly" (click)="removeFile(i)" tsl-icon-button>
                  <tsl-icon>close</tsl-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
  <div class="row">
    <div class="col-12 text-right">
      <button tsl-button *ngIf="!hideCancelButton" color="black" outline (click)="onCancel()">{{ translate.get(cancelBtnText) }}</button>
      <button tsl-button *ngIf="!hideSaveButton" color="blue" (click)="onSubmit()">{{ translate.get(saveBtnText) }}</button>
    </div>
  </div>
  <payout-angular id='payoutRefAngular' #payoutRefAngular [data]="payoutData"></payout-angular>
</ng-container>
